import React, { useContext } from 'react';
import { BoxNotification } from '../../../../components/containers/BoxNotification';
import { Modal } from '../../../../components/containers/Modal';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import { BeaconContext } from '../../../../providers/BeaconProvider';

export type DeleteCategoryModalViewProps = {
  onClose: () => void;
  onSubmit: () => void;
  submitted: boolean;
  isArchived: boolean;
};

export const DeleteCategoryModalView = (props: DeleteCategoryModalViewProps): JSX.Element => {
  const title = props.isArchived ? 'Delete Category' : 'Archive Category';
  const { beacon } = useContext(BeaconContext);
  return (
    <Modal
      closeOnClickOutside={!props.submitted}
      closeOnEsc={!props.submitted}
      onClose={props.onClose}
      showCloseIcon={!props.submitted}
      title={title}
      primaryButtonTitle={title}
      primaryButtonAction={props.onSubmit}
      primaryButtonColor={ButtonColorsEnum.alert}
      primaryButtonDisabled={props.submitted}
      primaryButtonLoading={props.submitted}>
      {props.isArchived ? (
        <>
          <p>Are you sure you want to remove this Category? There are no Posts in this Category.</p>
          <BoxNotification type={'error'}>
            Deleting a Category will also delete its Timeslots and Auto-Imports.
          </BoxNotification>
        </>
      ) : (
        <div>
          <p>Archiving a Category preserves all past and current Posts and Timeslots and makes them inactive.</p>
          <p>
            Any active Posts in your Queue will not be published. You will still be able to access these Posts in
            your Library.
          </p>
          <p>You can always revert a Category back to active.</p>
          <p>
            <a onClick={() => beacon('article', '592', { type: 'modal' })}>Learn more</a>.
          </p>
        </div>
      )}
    </Modal>
  );
};
